import { createAsyncThunk } from '@reduxjs/toolkit';
import ErrorNotifier, { Severity } from 'app/scripts/services/error-notifier';
import { createLiveBlog } from '../../api';
import { parseLiveEvent } from '../parsers';
import { LiveEvent } from './../types';
import { ILiveBlogModalState } from './../../components/Modal/reducer';

interface Payload extends ILiveBlogModalState {
  notifyEventCreated: (props: {
    liveEvent?: Partial<LiveEvent>;
    status: 'success' | 'failure';
  }) => void;
}

interface Returned {
  liveEvent: LiveEvent;
}

export const createLiveBlogEvent = createAsyncThunk<Returned, Payload>(
  'LIVE_BLOG/CREATE_LIVE_BLOG_EVENT',
  async ({
    displayName,
    timezone,
    startTime,
    endTime,
    reporterIds,
    notifyEventCreated
  }: Payload) => {
    try {
      const rawLiveEvent = await createLiveBlog({
        title: displayName,
        time: startTime.time,
        date: startTime.date,
        hour: startTime.hour,
        minute: startTime.minute,
        endMinute: endTime.minute,
        endHour: endTime.hour,
        endDate: endTime.date,
        endTime: endTime.time,
        timezone,
        reporterIds
      });
      const liveEvent = parseLiveEvent(rawLiveEvent);

      if (notifyEventCreated && typeof notifyEventCreated === 'function') {
        notifyEventCreated({ liveEvent, status: 'success' });
      }

      return { liveEvent };
    } catch (err) {
      console.error(err);
      notifyEventCreated({ status: 'failure' });
      ErrorNotifier.notifyError(`Failed to create live blog`, { severity: Severity.Critical });
      throw err;
    }
  }
);
